<template>
  <div>
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalLabel">{{ tp.confirm }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="cancelDelete()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">{{ messageProperty }}</div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="cancelDelete()"
          >
            {{ tp.cancel }}
          </button>
          <a
            href="#delete"
            id="delete"
            class="btn btn-primary"
            @click="okDelete()"
            >{{ tp.ok }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "confirmDialog",
  props: {
    messageProperty: String,
    tp: Object
  },
  methods: {
    okDelete() {
      this.$emit("okdelete");
    },
    cancelDelete() {
      this.$emit("canceldelete");
    }
  }
};
</script>
